<template>
    <template v-if="!isProductPage">
            
    <Header></Header>
    <main>
        <BreadCrumbs></BreadCrumbs>

        <FiltersWrapper @update="dialogs.filterDialog = true">
            <template #clear><ClearAllButton v-if="filters.category.value.length > 0 || filters.bottles.value.length > 0" @click="clearAll"></ClearAllButton></template>
            <template #search><Search v-model="filters.search" :sort="seacrhData" :data_name="'name'" @search="getSearchProducts"></Search></template>
            <template #sort><SortBy v-model="filters.sortBy" :sort="sortOptions"></SortBy></template>
        </FiltersWrapper>
        <ProductWrapper>
            <template #category><Category @update="dialogs.filterDialog = false" :class="{ 'show': dialogs.filterDialog == true }" v-model:filters="filters"
                ></Category></template>
            <template #product><ProductList :itemsPerRow="3" :products="arr_data"></ProductList></template>
            <template #list-flip>
                <ListFlip
                v-model:totalPages="data_info.totalPages" 
                v-model:currentPage="data_info.page" 
                ></ListFlip>
            </template>
        </ProductWrapper>
        <AlsoLike :fields="fields['Machines']">
            <template #list v-if="alsoLike.length > 0"><ProductList :itemsPerRow="4" :products="alsoLike"></ProductList></template>
        </AlsoLike>
        <FaqBlock style="padding-bottom: 120px;"></FaqBlock>
    </main>
    <Footer></Footer>
    </template>
    <router-view v-else />
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import BreadCrumbs from "@/components/UI/BreadCrumbs.vue";
import FiltersWrapper from "@/components/Products/FiltersWrapper.vue";
import ClearAllButton from "@/components/Products/ClearAllButton.vue";
import Search from "@/components/UI/Search.vue";
import SortBy from "@/components/UI/SortBy.vue";
import ProductWrapper from "@/components/Products/ProductWrapper.vue";
import ProductList from "@/components/Products/ProductList.vue";
import Category from "@/components/Products/Category.vue";
import AlsoLike from "@/components/Templates/AlsoLike.vue";
import ListFlip from "@/components/Products/ListFlip.vue";
import axios from "axios";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import { registerAnimations } from '@/assets/directives/animations';
export default {
    components: {
        Header,
        Footer,
        BreadCrumbs,
        FiltersWrapper,
        ClearAllButton,
        Search,
        SortBy,
        ProductWrapper,
        ProductList,
        Category,
        AlsoLike,
        ListFlip,
        FaqBlock
    },
    data() {
        return {
            arr_data: [],
            alsoLike: [],
            filters: {
                search: '',
                sortBy: 1,
                category: { open: true, value: []},
                bottles: { open: true, value: []},
                beverage: { open: true, value: []},
                // tank: { open: true, value: { from: '', to: '' } },
                // year: { open: true, value: { from: '', to: '' } }
            },
            seacrhData: [],
            sortOptions: [
                {id: 1,title:'Latest'}, 
                {id: 2,title:'Oldest'}, 
            ],
            data_info:{
                loading: true,
                page: 1,
                totalPages: 10,

            },
            dialogs:{
                filterDialog: false,
            }
        }
    },
    methods: {
        clearAll(){
            this.filters = {
                search: '',
                sortBy: 1,
                category: { open: true, value: []},
                bottles: { open: true, value: []},
                beverage: { open: true, value: []},
                // tank: { open: true, value: { from: '', to: '' } },
                // year: { open: true, value: { from: '', to: '' } }
            }
            this.getData();
        },
        getSearchProducts(e){
            let fData = new FormData();
            fData.append("name",e);
            axios.post("/get/products-search",fData).then(resp => {
            if (resp.data['result'] == true) {
                this.seacrhData = resp.data.blogs;
            }
            }).catch(()=>{}).finally(()=>{});
        },
        getData(){
            let fData = new FormData();
            fData.append("page",this.data_info.page);
            fData.append("filters",JSON.stringify(this.filters));
            axios.post("/get/products",fData).then(resp => {
                if (resp.data['result'] == true) {
                this.arr_data = resp.data.data;
                this.data_info.page = resp.data.current_page;
                this.data_info.totalPages = resp.data.total_pages;
                // this.data_info.minTank = resp.data.min_tank;
                // this.data_info.maxTank = resp.data.max_tank;
                // this.data_info.minYear = resp.data.min_year;
                // this.data_info.maxYear = resp.data.max_year;
                }
            }).catch(()=>{}).finally(()=>{
            });
            },
        async fetchBlogs() {
            try {
                let fData = new FormData();
                fData.append("slug", this.$route.params.slug);
                const response = await axios.post("/get/our-products",fData);
                if (response.data.result) {
                this.alsoLike = response.data.data;
                }
            } catch (error) {
                console.error("Ошибка при загрузке блогов:", error);
            }
        },
        fetchData() {
        axios.get('/api/data', { params: { url: this.$route.path } })
            .then(response => {
                this.$nextTick(() => {
                    registerAnimations(); // Инициализация анимаций после загрузки данных
                });
            });
        },
    },
    mounted () {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("category")) {
            // Разделяем значения категории, если их несколько, и добавляем в массив
            this.filters.category = this.filters.category || { value: [] };
            this.filters.category.value = [...new Set([...this.filters.category.value, ...urlParams.get("category").split(",")])];
            urlParams.delete("category");
        }

        if (urlParams.has("bottles")) {
            // Разделяем значения бутылок, если их несколько, и добавляем в массив
            this.filters.bottles = this.filters.bottles || { value: [] };
            this.filters.bottles.value = [...new Set([...this.filters.bottles.value, ...urlParams.get("bottles").split(",")])];
            urlParams.delete("bottles");
        }
        if (urlParams.toString() === '') {
            window.history.replaceState({}, "", window.location.pathname);  // Убираем все параметры и знак вопроса
        } else {
            // Обновляем URL с оставшимися параметрами
            window.history.replaceState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
        }
        this.getData();
        this.fetchBlogs();
        this.getSearchProducts('');
    },
    created() {
        this.fetchData(); // Загружаем данные при создании компонента
    },
    computed: {
        isProductPage() {
        return !!this.$route.params.slug;
        },
        fields() {
            return this.$store.state.fields;
        },
    },
    watch: {
        '$route': 'fetchData', 
        'filters.search': function(newValue, oldValue) {
            this.data_info.page = 1;
        this.getData(); // Функция будет вызвана при изменении поиска
        },
        'filters.sortBy': function(newValue, oldValue) {
            this.data_info.page = 1;
        this.getData(); // Функция будет вызвана при изменении сортировки
        },
        'filters.bottles.value': function(newValue, oldValue) {
            this.data_info.page = 1;
            this.getData(); // Функция будет вызвана при изменении сортировки
        },
        'filters.category.value': function(newValue, oldValue) {
            this.data_info.page = 1;
        this.getData(); // Функция будет вызвана при изменении сортировки
        },
        'filters.beverage.value': function(newValue, oldValue) {
            this.data_info.page = 1;
        this.getData(); // Функция будет вызвана при изменении сортировки
        },
        // 'filters.tank.value': function(newValue, oldValue) {
        //     this.data_info.page = 1;
        // this.getData(); // Функция будет вызвана при изменении поиска
        // },
        // 'filters.year.value': {
        //     handler(newValue, oldValue) {
        //         this.data_info.page = 1;
        //         this.getData();
        //     },
        //     deep: true
        // },
        'data_info.page': function(newValue, oldValue) {
        this.getData(); // Функция будет вызвана при изменении сортировки
        window.scrollTo({
        top: 90,
        behavior: 'smooth' // Для плавной прокрутки
        });
        },
    }
}
</script>

<style scoped>

</style>